<ng-container *ngIf="this._UserHelper.isSignedIn">
  <div class="mobile-page-header">
    <div class="left-side">
      <ng-container [ngSwitch]="['b500'] | getProductName">
        <ng-container *ngSwitchCase="'b500'"> {{ 'b3000_my_bets' | t }} ({{ cashoutSlipsList.length }}) </ng-container>
        <ng-container *ngSwitchDefault> {{ 'b3000_my_bets' | t }} ({{ this._DataHelper.cashoutSlipsList.length }}) </ng-container>
      </ng-container>
    </div>
  </div>
  <mat-accordion>
    <ng-container [ngSwitch]="['b500', 'bettarena'] | getProductName">
      <ng-container *ngSwitchCase="'b500'"></ng-container>
      <ng-container *ngSwitchCase="'bettarena'"></ng-container>
      <ng-container *ngSwitchDefault>
        <div class="cashout-info-general-container" *ngIf="!this._UserHelper.customerUser.IsCashOutInfo">
          <div class="cashout-info-container">
            <span class="underline-span"> Info: </span>
            {{ 'Cashout_Info' | t }}
            <div class="cashout-info-button-container">
              <div class="button-row" (click)="cashoutInfo()">
                <div class="infoButton">
                  <div class="btn-text mobile-text">
                    {{ 'OK' | t }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngFor="let item of this._DataHelper.cashoutSlipsList; trackBy: trackBySlipId">
      <mat-expansion-panel
        class="cashout-expansion-panel mat-elevation-z0"
        [expanded]="lastSlipId === item.SlipId"
        (closed)="Cashout_ExpansionPanel_Close(item.SlipId)"
        (opened)="Cashout_ExpansionPanel_Open(item.SlipId)"
        (click)="getCashoutSlipDetail(item.SlipId)">
        <mat-expansion-panel-header class="cashout-expansion-panel-header text">
          <div class="cashout-header-container">
            <div class="slip-type">
              {{ item.SlipType }}
              <div *ngIf="item.isLive" class="live-badge">
                {{ 'LIVE' | t }}
              </div>
            </div>
            <div>
              <span> {{ 'Possible_Winnings' | t }} : </span>
              <span class="bold-700"> {{ item.PossibleGain }} {{ _UserHelper.customerUser?.Symbol }} </span>
            </div>
            <div>
              <span> {{ 'Total_Stake' | t }} : </span>
              <span class="bold-700">
                {{ item.Amount | balanceFormat }}
              </span>
            </div>
          </div>
        </mat-expansion-panel-header>
        <div class="cashout-detail-container text">
          <ng-container *ngIf="item['details'] != undefined">
            <div class="cashout-detail-item" (click)="goDetail(cashoutItem)" *ngFor="let cashoutItem of item['details'] | groupbymatchid | sortBy : false : 'EventDateIso'">
              <div class="team-box">
                <div class="banko-box" *ngIf="cashoutItem.Banko == 1">
                  <div class="banko-button">B</div>
                </div>
                <div class="team-name">
                  <div class="home">{{ cashoutItem.HomeTeam }}</div>
                  <div class="away">{{ cashoutItem.AwayTeam }}</div>
                </div>
                <div class="match-time">
                  <ng-container *ngIf="cashoutItem.IsLive || cashoutItem.MatchStatus === 'Beendet'">
                    {{ cashoutItem.MatchStatus }}
                  </ng-container>
                </div>
                <div class="team-score">
                  <div class="score">
                    {{ cashoutItem.HomeTeamScore }}
                    <ng-container *ngIf="!cashoutItem.IsLive && cashoutItem.MatchStatus !== 'Beendet'">
                      <span style="font-weight: 400; margin-left: 13px">
                        {{
                          (cashoutItem.EventDateIso | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM')
                            ? ('today' | t)
                            : (cashoutItem.EventDateIso | dateFormat : 'dd.MM')
                        }}
                      </span>
                    </ng-container>
                  </div>
                  <div class="score">
                    {{ cashoutItem.AwayTeamScore }}
                    <ng-container *ngIf="!cashoutItem.IsLive && cashoutItem.MatchStatus !== 'Beendet'">
                      <span style="font-weight: 400; margin-left: 13px">
                        {{ cashoutItem.EventDateIso | dateFormat : 'H:mm' }}
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="odd-box" *ngFor="let oddInfo of cashoutItem.oddInfos">
                <div class="odd-left">
                  {{ oddInfo.OddType }} {{ oddInfo.SpecialBetValue }}
                  <b>
                    {{ oddInfo.Outcome }}
                  </b>
                </div>
                <div class="odd-state">
                  <image-loader-utils *ngIf="oddInfo.State === 'Won'" url="check-circle" extraClasses="check-circle-icon won"></image-loader-utils>
                  <image-loader-utils *ngIf="oddInfo.State === 'Lost'" url="check-circle" extraClasses="check-circle-icon lost"></image-loader-utils>
                </div>
                <div class="odd-right">
                  {{ oddInfo.CustomerOddValue }}
                </div>
              </div>

              <div class="odd-box relative" *ngIf="cashoutItem.MatchTime && cashoutItem.MatchTime !== ''">
                <div class="odd-left">{{ 'b3000_score' | t }} : {{ cashoutItem.MatchTime }}</div>
                <div *ngIf="!cashoutItem.MatchIsActive" class="cashout-lock-reason">
                  <div class="message">
                    <div class="lock-icon">
                      <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                    </div>
                    <div class="reason-text">
                      {{ cashoutItem.Reason }}
                    </div>
                    <div class="lock-icon">
                      <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="item['details'] == undefined">
            <ngx-skeleton-loader [theme]="{ height: '50px', width: '100%', background: 'var(--white-color-300)' }" count="3"> </ngx-skeleton-loader>
          </ng-container>
        </div>
      </mat-expansion-panel>
      <div class="cashout-button-box">
        {{ item.MatchIsActive }}

        <div class="cashout-submit-message" *ngIf="item.cashoutSubmitMessageIsActive">
          {{ 'b3000_cashout_submit_message' | t }}
        </div>

        <ng-container *ngIf="cashoutApproveSlipId != item.SlipId">
          <div class="cashout-value-button" *ngIf="(item.CashoutValue | cashoutBalance) !== 0" (click)="cashoutApprove(item.SlipId)">
            Cashout &nbsp;<span [ngClass]="{ cashoutInitial: item.State == 0, cashoutgoUp: item.State == 1, cashoutgoDown: item.State == 2 }">{{ item.CashoutValue }}</span
            >&nbsp; {{ _UserHelper.customerUser?.Symbol }}
          </div>
        </ng-container>

        <ng-container *ngIf="cashoutApproveSlipId == item.SlipId">
          <div class="cashout-approve-box">
            <div class="cashout-value-button confirm" *ngIf="(item.CashoutValue | cashoutBalance) !== 0" (click)="cashOut(item.SlipId, cashOutValue)">
              {{ 'Confirm' | t }}
            </div>

            <div class="cashout-value-button modify" *ngIf="(item.CashoutValue | cashoutBalance) !== 0" (click)="cashoutModify()">
              {{ 'b3000_cancel' | t }}
            </div>
          </div>
        </ng-container>

        <div class="cashout-value-button lock" *ngIf="(item.CashoutValue | cashoutBalance) === 0">
          <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
        </div>
        <div class="bet-slips-detail-text" *ngIf="lastSlipId === item.SlipId">
          <span (click)="OpenAccountMobile(1, item.SlipId)">{{ 'BETTING_SLIP_DETAILS' | t }}</span>
        </div>
      </div>
    </ng-container>
  </mat-accordion>

  <mat-card class="attention-card" *ngIf="this._DataHelper.cashoutSlipsList.length == 0">{{ 'Cashout_Length_Zero' | t }}</mat-card>
</ng-container>
